import app from 'flarum/forum/app';
export default class PollState {
  loadingOptions = false;
  pendingSubmit = false;
  pendingOptions = null;
  constructor(poll, post) {
    this.poll = poll;
    this.post = post;
    this.init();
  }
  init() {}

  // The server omits the count entirely while votes are hidden, so its
  // absence is the permission check.
  get canSeeVoteCount() {
    return typeof this.poll.voteCount() === 'number';
  }
  get useSubmitUI() {
    return !this.poll.canChangeVote() && this.poll.allowMultipleVotes();
  }
  canSelect() {
    if (this.loadingOptions || this.poll.hasEnded()) return false;

    // Guests get a live control: clicking it asks them to log in.
    if (!app.session.user) return true;
    if (!this.poll.canVote()) return false;
    return !this.hasVoted() || this.poll.canChangeVote();
  }
  isShowResult() {
    return this.poll.hasEnded() || this.canSeeVoteCount && !!app.session.user && this.hasVoted();
  }
  hasVoted() {
    return this.poll.myVotes().length > 0;
  }
  overallVoteCount() {
    return this.poll.voteCount();
  }
  hasVotedFor(option) {
    return this.pendingOptions ? this.pendingOptions.has(option.id()) : this.poll.myVotes().some(vote => vote.option() === option);
  }
  getMaxVotes() {
    const poll = this.poll;
    let maxVotes = poll.allowMultipleVotes() ? poll.maxVotes() : 1;
    if (maxVotes === 0) maxVotes = poll.options().length;
    return maxVotes;
  }
  showButton() {
    return this.useSubmitUI && this.pendingSubmit;
  }
  changeVote(option, evt) {
    const target = evt.target;
    if (!app.session.user) {
      app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'));
      target.checked = false;
      return;
    }
    const optionIds = this.pendingOptions || new Set(this.poll.myVotes().map(v => v.option().id()));
    const isUnvoting = optionIds.delete(option.id());
    if (!this.poll.allowMultipleVotes()) {
      optionIds.clear();
    }
    if (!isUnvoting) {
      optionIds.add(option.id());
    }
    this.pendingOptions = optionIds.size ? optionIds : null;
    this.pendingSubmit = !!this.pendingOptions;
    if (this.useSubmitUI) {
      m.redraw();
      return;
    }
    this.submit(optionIds, () => {
      this.pendingOptions = null;
      this.pendingSubmit = false;
    }, () => target.checked = isUnvoting);
  }
  hasSelectedOptions() {
    return this.pendingSubmit;
  }
  onsubmit() {
    return this.submit(this.pendingOptions, () => {
      this.pendingOptions = null;
      this.pendingSubmit = false;
    });
  }
  submit(optionIds, cb, onerror) {
    if (onerror === void 0) {
      onerror = null;
    }
    this.loadingOptions = true;
    m.redraw();
    return app.request({
      method: 'PATCH',
      url: `${app.forum.attribute('apiUrl')}/polls/${this.poll.id()}/votes`,
      body: {
        data: {
          optionIds: Array.from(optionIds)
        }
      }
    }).then(res => {
      app.store.pushPayload(res);
      cb?.();
    }).catch(err => {
      onerror?.(err);
    }).finally(() => {
      this.loadingOptions = false;
      m.redraw();
    });
  }
  showVoters = () => {
    app.modal.show(() => import(/* webpackChunkName: 'forum/components/ListVotersModal', webpackMode: 'lazy-once' */ '../components/ListVotersModal'), {
      poll: this.poll,
      post: this.post
    });
  };
}
flarum.reg.add('fof-polls', 'forum/states/PollState', PollState);flarum.reg.addChunkModule('540', '2649', 'fof-polls', 'forum/components/ListVotersModal');